import * as R from 'ramda'

const getMyOrderData = (state:any) => R.pathOr([],['CustomerMyOrder','myOrderData'],state)
const getApprovalHistory = (state:any) => R.pathOr([], ['CustomerMyOrder', 'approvalHistory'], state);
const getAssignmentType = (state: any) => R.pathOr([], ['CustomerMyOrder', 'assignmentType'], state);
const getRequestReason = (state: any) => R.pathOr([], ['CustomerMyOrder', 'requestReason'], state);
const getRowData = (state:any) => R.pathOr('', ['CustomerMyOrder', 'data'], state);
const getActionValue = (state:any) => R.pathOr('', ['CustomerMyOrder', 'actionValue'], state);

const selectors = {
    getMyOrderData,
    getApprovalHistory,
    getAssignmentType,
    getRequestReason,
    getRowData,
    getActionValue
}

export default selectors